export default __webpack_public_path__ + "static/media/empty-room.c8301e2a.svg";